<template>
  <div>
    <v-dialog
      v-model="mostrarModal"
      persistent
      :max-width="listaTamanhos[tamanho]"
      :full-screen="tamanho === 'full'"
      ref="mainModal"
    >
      <v-card>
        <v-toolbar
          dense      
          flat
          color="grey lighten-3"
          v-if="toolbar"
        >

          <v-card-title class="text-h5">
            {{ titulo }}
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="minimizar"
            color="black"
            :elevation="0"
            fab
            dark
            outlined
            text
            x-small
            @click="minimizarModal"
          >
            <v-icon dark>
              mdi-minus
            </v-icon>
          </v-btn>

          <v-btn
            v-if="permitirFechar"
            class=""
            fab
            dark
            outlined
            text
            x-small
            color="black"
            :elevation="0"
            @click="fecharModal"
            
          >
            <v-icon dark>
              mdi-close
            </v-icon>
          </v-btn>
          
        </v-toolbar>
        
        <v-card-text class="pt-7">
          <slot></slot>
        </v-card-text>
      </v-card>
      
    </v-dialog>
    
  </div>
</template>

<script>

export default {
  name: 'SGPModalComponent',

  props: {
    titulo: {
      type: String,
      required: true,
      default: ''
    },
    tamanho: {
      type: String,
      required: false,
      default: 'sm'
    },
    mostrarHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    mostrarBody: {
      type: Boolean,
      required: false,
      default: true
    },
    mostrarFooter: {
      type: Boolean,
      required: false,
      default: true
    },

    toolbar: {
      type: Boolean,
      required: false,
      default: true
    },

    permitirFechar: {
      type: Boolean,
      required: false,
      default: true
    },

    minimizar : {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      mostrarModal: false,
      listaTamanhos: {
        'xs': 380,
        'sm': 440,
        'md': 580,
        'lg': 768,
        'xl': 1180
      }
    }
  },

  mounted () {
    this.mostrarModal = true
  },

  methods: {
    minimizarModal () {
      this.mostrarModal = false
      setTimeout( () => {
        this.$emit('sgpModalMinimizar')
      }, 300)
    },

    fecharModal () {
      this.mostrarModal = false
      setTimeout( () => {
        this.$emit('sgpModalFechar')
      }, 300)
    }
  }
}
</script>

